import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'any',
})
export class NotificationDataService {
  private apiUrlBanner = `${environment.dwApiUrl}/banner/BANNER`;
  private apiUrlPasswordReset = `${environment.dwApiUrl}/banner/PASSWORD RESET`;
  private tokenUrl = `${environment.dwApiUrl}/user/token`;
  private token: string | null = null;

  constructor(private http: HttpClient) {}

  getBannerText(): Observable<any> {
    return this.http.get<any>(this.apiUrlBanner).pipe(catchError(this.handleError));
  }

  getBannerPasswordReset(): Observable<any> {
    return this.http.get<any>(this.apiUrlPasswordReset).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Backend error
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
